<aw-modal
  #modal
  [zIndex]="zIndex()"
  [size]="size()"
  [showCloseButton]="true"
  [title]="title()"
  (hiding)="onCancel()"
>
  <div>
    @if (image()) {
      <div class="image-container" [style.width.px]="image().width" [style.height.px]="image().height">
        <img [src]="image().path" [alt]="image().alt" />
      </div>
    }
    @if (highlightedText()) {
      <aw-info-box
        class="aw-2-mb--s"
        [text]="highlightedText()"
        [color]="actionColor()"
        [centerText]="true"
        [width]="InfoBoxWidth.Stretch"
      />
    }
    @if (subtitle()) {
      <p
        class="subtitle"
        [class.aw-2-px--m]="size() === Size.m"
        [class.aw-2-txt--center]="centerSubtitle()"
        [innerHTML]="subtitle()"
      ></p>
    }
  </div>

  <ng-content />

  <div modal-footer class="footer">
    @if (cancelText()) {
      <aw-button [type]="'tertiary'" [size]="Size.m" [text]="cancelText()" (onClick)="onCancel()" />
    }

    <aw-button
      [color]="actionColor()"
      [type]="'primary'"
      [size]="Size.m"
      [text]="actionText()"
      [loadingText]="loadingText()"
      [state]="buttonState()"
      (onClick)="onConfirm()"
    />
  </div>
</aw-modal>
